import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs/Subscription';
import { saveAs } from 'file-saver';

import { DealerService } from '../shared/dealer.service';
import { Dealer } from '../shared/dealer.model';
import { EditDealerComponent} from '../edit-dealer/edit-dealer.component'
import * as _ from 'lodash';
@Component({
  selector: 'app-list-dealer',
  templateUrl: './list-dealer.component.html',
  styleUrls: ['./list-dealer.component.css']
})
export class ListDealerComponent implements OnInit, AfterViewInit {

  public dealers: Dealer[];

  dealerSubscription: Subscription;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public displayedColumns: string[] = ['id', 'name', 'location', 'postcode', 'distance', 'maxCPC' , 'displayName' ,'displaylocation', 'actions'];
  public dealerTableDataSource = new MatTableDataSource<Dealer>();

  constructor(private dealerService: DealerService, private dialog: MatDialog, private router : Router ) { }

  ngOnInit() {
    this.dealerSubscription = this.dealerService.dealersChanged.subscribe(d => {
      this.dealers = d;
       this.dealerTableDataSource.data = this.dealers;
    });
    this.dealerService.fetchDealers();
   
  }
  ngAfterViewInit() {
    this.dealerTableDataSource.sort = this.sort;
    this.dealerTableDataSource.paginator = this.paginator;
  }

  onEdit(row) {
    row = _.omit(row, 'dealerAdGroup');
    row = _.omit(row, 'dealerFeature');
    this.dealerService.dealerData = Object.assign({}, row);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    this.dialog.open(EditDealerComponent, dialogConfig);
  }
  onDelete(row) {
    if (confirm('Are you sure to delete this record ?')) {
      this.dealerService.deleteDealer(row);
      this.dealerService.fetchDealers();
      //this.translationService.deleteTranslation(transID);
      //this.notificationService.warn('! Deleted successfully');
    }  
  }
  onInfo(row) {
    row = _.omit(row, 'dealerAdGroup');
    row = _.omit(row, 'dealerFeature');
    this.dealerService.dealerData = Object.assign({}, row);
    this.router.navigateByUrl('/dealerdetails');
  }

  onCreate() {

    this.dealerService.dealerData = {
      id: null,
      displayLocation: '',
      displayName: '',
      distance: 0,
      feedId: '',
      location: '',
      maxCpc: 0,
      name: '',
      postCode: '',
      siteLinks: '',
      address: '',
      email: '',
      keyContact: '',
      maxBidprice: 0,
      parentDealerid: 0,
      status: 0
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    this.dialog.open(EditDealerComponent, dialogConfig);

  }

  onImport() {
    this.dealerService.onImport();
  }
  //Filter Translation 
  doFilter(filterValue: string) {
    this.dealerTableDataSource.filter = filterValue.trim().toLowerCase();

  }

  onGenerateAds() {
    this.dealerService.onGenerateAdsByClient(17);

  }
  
  onBackgroundJob() {
    this.dealerService.onBackgroundJob();
  }

  onCompareAds() {
    this.dealerService.onCompareAds();
  }

  download() {
    
    this.dealerService.downloadFile()
      .subscribe(
        data => saveAs(data, 'output.zip'),
        error => console.error(error)
      );
  }
}
